<template>
  <VToolbar
    height="64"
    :clipped-left="$vuetify.breakpoint.mdAndUp"
    color="mainHeader"
    dark
    app
    fixed
  >
    <VToolbarTitle
      style="width: 300px"
      class="ml-0 pl-3"
    >
      <VToolbarSideIcon @click.stop="navigationBarToggled" />
      <span>{{ pageName }}</span>
    </VToolbarTitle>
    <VTextField
      flat
      solo-inverted
      prepend-icon="search"
      label="Search"
      class="hidden-sm-and-down"
    />
    <VSpacer />
    <VBtn
      v-if="massTextIcon"
      icon
      @click.prevent="onMassTextToggled"
    >
      <VIcon
        :disabled="massTextDisabled"
      >
        mdi-volume-high
      </VIcon>
    </VBtn>
    <VMenu
      origin="center center"
      transition="scale-transition"
    >
      <VBtn
        v-show="isEditBtnVisible"
        slot="activator"
        dark
        icon
      >
        <VIcon>edit</VIcon>
      </VBtn>
      <VList>
        <VListTile
          v-for="(item, i) in menuItems"
          :key="i"
          :to="item.route"
        >
          <VListTileTitle>{{ item.title }}</VListTileTitle>
        </VListTile>
      </VList>
    </VMenu>
    <!--<VBtn-->
    <!--icon-->
    <!--@click.prevent="onNotificationBtnClicked"-->
    <!--&gt;-->
    <!--<VIcon>notifications</VIcon>-->
    <!--</VBtn>-->
    <VBtn
      :loading="isLoggingOut"
      :disabled="isLoggingOut"
      color="light-blue darken-4"
      @click.prevent="logOut"
    >
      LOG OUT
    </VBtn>
  </VToolbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ToolBar',
  props: {
    massTextIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isLoggingOut: 'authentication/isLoading',
      getVisibility: 'navigationDrawer/getVisibility',
      menuItems: 'toolBar/getEditMenuItems',
      getMassTextIcon: 'toolBar/getMassTextIcon'
    }),
    pageName () {
      return this.$route.meta.pageName
    },
    isEditBtnVisible () {
      return this.menuItems.length > 0
    },
    massTextDisabled: {
      get: function () {
        return this.getMassTextIcon.disabled
      },
      set: function (val) {
        this.setMassTextIconDisabled({ val })
      }
    }
  },
  methods: {
    ...mapActions({
      logOut: 'authentication/logOutAll',
      setVisibility: 'navigationDrawer/setVisibility',
      setMassTextIconDisabled: 'toolBar/setMassTextIconDisabled',
      setNotificationValue: 'toolBar/setNotificationValue'
    }),
    navigationBarToggled () {
      this.setVisibility({ val: !this.getVisibility })
    },
    onMassTextToggled () {
      if (!this.getMassTextIcon.toggleDisabled) {
        this.massTextDisabled = !this.massTextDisabled
      }
    },
    onNotificationBtnClicked () {
      // show dialog
      this.setNotificationValue({ val: true })
    }
  }
}
</script>

<style scoped>

</style>
